angular.module('capability-ng-global').directive('disableAnimate', function($animate) {
  return {
    link: function(scope, element) {
      $animate.enabled(element, false);
    }
  };
});



// WEBPACK FOOTER //
// ./app/lib/global/directives/disable_animate/disable_animate.ts